/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-14 10:57:42
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/VirtualProduct/Tags/index.tsx
 */
import { SectionContent } from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
import { getI18nFromGeneral } from '@/src/tools/tools';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import GreenLink from 'src/components/Link/GreenLink';
import { StyledTitle } from 'src/layout/EditorPageLayout/SectionTitle';
import Tags from '../../Components/Tags/Tags';
import SectionHOC from '../HOC';
import { EnumCollapseId, getTags, onTagsChange } from '../slice';

const TagsSection = (props) => {
  const { tags } = useSelector(getTags());

  const [inputTags, setInputTags] = useState('');

  return (
    <SectionContent>
      <Tags
        disabled={props.disabled}
        hideSectionTitle
        setInputTags={setInputTags}
        tags={tags}
        inputTags={inputTags}
        setTags={onTagsChange}
      />
    </SectionContent>
  );
};
export default SectionHOC(TagsSection, {
  id: EnumCollapseId.ProductInfo,
  title: (
    <StyledTitle
      left={getI18nFromGeneral('general.hOCTitle.tags')}
      right={
        <GreenLink to='/settings/tagManager'>
          {getI18nFromGeneral('general.hOCTitle.viewallTags')}
        </GreenLink>
      }
    />
  ),

  useCustomCollapseTitle: true,
});
